import WS_CLUSTER_ASSORTMENT_PRODUCTS from './getClusterAssortmentProducts.graphql'

export { WS_CLUSTER_ASSORTMENT_PRODUCTS }
